import { TYPE_KEY } from "../common/constant";

export const BEGIN_LOADING = "BEGIN_LOADING";
export const END_LOADING = "END_LOADING";

export const OPEN = "open";

export const initialState = {
  [OPEN]: false
};

export default function reducer(state = initialState, action) {
  let newState;
  switch (action[TYPE_KEY]) {
    case BEGIN_LOADING:
      newState = {
        ...state,
        [OPEN]: true
      };
      break;

    case END_LOADING:
      newState = {
        ...state,
        [OPEN]: false
      };
      break;

    default:
      newState = {
        ...state
      };
      break;
  }
  return newState;
}

export function beginLoading() {
  return {
    [TYPE_KEY]: BEGIN_LOADING
  };
}

export function endLoading() {
  return {
    [TYPE_KEY]: END_LOADING
  };
}

/**
 * Wraps an async call with automatic loading state handling.
 *
 * @param {Function} dispatch - Redux dispatch function
 * @param {Promise|Function} asyncFn - A function returning a Promise or a Promise itself
 * @param {Function} [onError] - Optional callback to handle errors
 */
export const withLoading = (dispatch, asyncFn, onError) => {
  dispatch(beginLoading());

  let promise;
  try {
    // Allow passing either a function or a raw Promise
    promise = typeof asyncFn === "function" ? asyncFn() : asyncFn;
  } catch (err) {
    // Synchronous error (e.g. before asyncFn even returns)
    if (onError) onError(err);
    dispatch(endLoading());
    return Promise.reject(err);
  }

  return promise
    .catch((err) => {
      if (onError) onError(err);
      return Promise.reject(err); // keep propagation
    })
    .then((res) => res)
    .then(
      (res) => res,
      (err) => err // ensures the next then still runs
    )
    .then((res) => {
      dispatch(endLoading());
      return res;
    });
};
